import React, { useContext, Fragment } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import DataContext from '../../data/DataContext';

const styles = (theme) => ({
  root: {
    display: 'flex',
    // letterSpacing: "-0.5px",
    fontWeight: '300',
    marginTop: '6px',
  },
  leftContainer: {
    justifyContent: 'flex-start',
  },
  rightContainer: {
    justifyContent: 'flex-end',
  },
  message: {
    fontSize: theme.font.size14,
    borderRadius: '12px',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    backgroundColor: theme.color.message.background,
    // padding: "13px 19px 13px 20.5px",
    lineHeight: '1.43',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    padding: '12px 16px',
    width: '16.25rem',
    // maxWidth: "75%",
    wordWrap: 'break-word',
    wordBreak: 'normal',
  },
  leftMessage: {
    // backgroundColor: "white",
    margin: '0 16px 6px 16px',
  },
  rightMessage: {
    // backgroundColor: theme.color.message.background,
    margin: '26px 10px',
    boxShadow: 'none',
  },
  gridContainer: {
    width: '100%',
    display: 'flex',
    margin: '12px 0px',
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    padding: '6px 20px',
    alignItems: 'stretch',
  },
  buttonContainer: {
    padding: '2px',
    fontWeight: 'bold',
    display: 'flex',
  },
  buttonItem: {
    // minWidth: 'fit-content',
    width: '100%',
    minHeight: '2em',
    padding: '0px 20px',
    background: '#fff',
    border: '1px solid #0a8297',
    fontSize: '0.875em',
    color: '#0a8297',
    borderRadius: '1em',
    textTransform: 'none',
    fontWeight: 'bold',
    // outline: "0 none",
    // "&:active": {
    //   background: "#0a8297",
    //   color: "#fff"
    // },
    lineHeight: 1,
    whiteSpace: 'normal',
  },
  '@media screen and (max-width:767px)': {
    message: {
      width: '100%',
    },
  },
});

const GridButtonsRaw = (props) => {
  const { classes, data } = props;
  const context = useContext(DataContext);

  const handleClick = (button) => {
    context.request(context, button.speech, 'button');
  };
  return (
    !context.conversationEnd && (
      <>
        <Grid container className={classes.buttonRow} direction="row">
          {data.buttons.map((button, key) => (
            <Grid item xs={6} key={key} className={classes.buttonContainer}>
              <button
                type="button"
                className={classes.buttonItem}
                onClick={() => handleClick(button)}
                aria-label={`${button.label}, ${key + 1} / ${data.buttons.length}`}
              >
                {button.label}
              </button>
            </Grid>
          ))}
        </Grid>
      </>
    )
  );
};

const GridButtons = withStyles(styles)(GridButtonsRaw);

function DeviceGrid(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  return (
    <>
      {data.text && data.text !== '' && (
        <div
          className={[
            classes.root,
            data.mine ? classes.rightContainer : classes.leftContainer,
          ].join(' ')}
          role={'text'}
          tabIndex={0}
          aria-label={`${context.string.aria.chatbotMessage} ${data.text}`} /*, ${moment(data.date, "LT").format("A hh시 mm분")}`}*/
        >
          <p
            className={[
              classes.message,
              data.mine ? classes.rightMessage : classes.leftMessage,
            ].join(' ')}
          >
            {data.text.split('\n').map((content, key) => (
              <Fragment key={key}>
                {content}
                <br />
              </Fragment>
            ))}
          </p>
        </div>
      )}
      {data.isLast && <GridButtons className={classes.gridContainer} data={data} />}
    </>
  );
}
export default withStyles(styles)(DeviceGrid);
